import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {Subject, takeUntil} from 'rxjs';
import {PracticeService} from '../../services/practice/practice.service';
import {PracticeModel} from '../../models/practice/practice.model';
import {iResponse} from '../../models/response/response.model';

@Component({
    selector: 'app-practice-create',
    imports: [
        FormsModule,
        MatInput,
        ReactiveFormsModule
    ],
    templateUrl: './practice-create.component.html',
    styleUrl: './practice-create.component.sass'
})
export class PracticeCreateComponent implements OnInit, OnDestroy {
    @Output() triggerPracticeCreate: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() triggerPracticeEdit: EventEmitter<string> = new EventEmitter<string>();
    @Input() practice!: PracticeModel;
    private destroy$ = new Subject<void>()
    practiceForm: FormGroup = new FormGroup({
        id: new FormControl(''),
        name: new FormControl('', Validators.required),
        street: new FormControl('', Validators.required),
        houseNumber: new FormControl('', Validators.required),
        zipCode: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required)
    })

    constructor(
        private practiceService: PracticeService
    ) {
    }

    ngOnInit(): void {
        if (this.practice) {
            console.log('patch', this.practice)
            this.practiceForm.patchValue(this.practice);
            this.practiceForm.get('name')?.patchValue(this.practice.name);
            this.practiceForm.get('street')?.patchValue(this.practice.address.street);
            this.practiceForm.get('houseNumber')?.patchValue(this.practice.address.houseNumber);
            this.practiceForm.get('zipCode')?.patchValue(this.practice.address.zipCode);
            this.practiceForm.get('city')?.patchValue(this.practice.address.city);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    submit(): void {
        if (this.practiceForm.invalid) {
            this.practiceForm.markAllAsTouched();
            return;
        }

        if (this.practice) {

            this.editPractice(this.practiceForm.value);
        } else {

            this.postPractice(this.practiceForm.value);
        }
    }

    cancel(): void {
        if (this.practice) {
            this.triggerPracticeEdit.emit(this.practice.id);
        } else {
            this.triggerPracticeCreate.emit(false);
        }
    }

    private postPractice(practice: PracticeModel): void {
        this.practiceService.postPractice(practice)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PracticeModel>) => {
                    this.triggerPracticeCreate.emit(true);
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private editPractice(practice: PracticeModel): void {
        this.practiceService.updatePractice(practice)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PracticeModel>) => {
                    this.triggerPracticeEdit.emit(practice.id);
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

}
